var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardicon04(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1011 46.1202H11.627V51.5514H43.1011V46.1202Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.89 52.3527H9.88086V53.9999H44.89V52.3527Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6055 41.5794H19.1231C17.1214 41.5794 15.5029 43.2711 15.5029 45.3634H39.2257C39.2257 43.2711 37.6072 41.5794 35.6055 41.5794Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2597 23.8615H25.5117V43.0041H29.2597V23.8615Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2597 17.2728H25.5117V19.5877H29.2597V17.2728Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.026 21.8582C30.026 22.5259 29.515 23.0601 28.8761 23.0601H25.8096C25.1707 23.0601 24.6597 22.5259 24.6597 21.8582C24.6597 21.1904 25.1707 20.6562 25.8096 20.6562H28.8761C29.515 20.6562 30.026 21.1904 30.026 21.8582Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13466 11.7081C8.13466 12.2869 7.66617 12.7766 7.1125 12.7766C6.55882 12.7766 6.09033 12.2869 6.09033 11.7081C6.09033 11.1294 6.55882 10.6397 7.1125 10.6397C7.70876 10.6397 8.13466 11.1294 8.13466 11.7081Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4583 27.2894H0.851562L7.15491 11.1295L13.4583 27.2894ZM1.49042 26.8442H12.862L7.15491 12.2869L1.49042 26.8442Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 26.5327H14.3103C14.3103 26.5327 13.3307 33.0322 7.15515 33.0322C0.979574 33.0322 0 26.5327 0 26.5327Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9647 8.32477C28.5354 8.32477 27.3854 11.8417 27.3854 11.8417C27.3854 11.8417 26.2355 8.32477 21.8061 8.32477C16.5675 8.32477 11.0734 13.3553 6.47363 12.4649C8.64573 14.9134 14.1825 14.8244 20.6562 12.4649C25.4689 10.6842 25.554 16.6051 25.554 16.6051H27.428H29.302C29.302 16.6051 29.3872 10.6842 34.1999 12.4649C40.631 14.8244 46.1677 14.9134 48.3824 12.4649C43.6975 13.3553 38.2033 8.32477 32.9647 8.32477Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5933 11.7081C46.5933 12.2869 47.0618 12.7766 47.6154 12.7766C48.1691 12.7766 48.6376 12.2869 48.6376 11.7081C48.6376 11.1294 48.1691 10.6397 47.6154 10.6397C47.0618 10.6397 46.5933 11.1294 46.5933 11.7081Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9192 27.2894H41.3125L47.6158 11.1295L53.9192 27.2894ZM41.9514 26.8442H53.3229L47.6584 12.2869L41.9514 26.8442Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7708 26.5327H40.4604C40.4604 26.5327 41.44 33.0322 47.6156 33.0322C53.7912 33.0322 54.7708 26.5327 54.7708 26.5327Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2373 8.99261H26.5337V13.845H28.2373V8.99261Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5334 8.50291L24.3613 3.11627H30.0258L28.237 8.50291H26.5334Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3613 3.11624C24.3613 3.11624 24.5743 0 27.2149 0C29.8555 0 30.0684 3.11624 30.0684 3.11624L27.513 4.85243L24.3613 3.11624Z",
    fill: "#E9E6D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardicon04);
export default __webpack_public_path__ + "static/media/cardicon04.05c2884f5b14d8160e8735ccb7674c69.svg";
export { ForwardRef as ReactComponent };